module.exports = __webpack_public_path__ + "static/media/creative_minds.ada24759.webp";